import { Transaction, TransactionStatus } from '../api/types'

export const isTransactionClosed = (transaction: Transaction): boolean =>
  transaction.status === TransactionStatus.Processed

export const isTransactionOpen = (transaction: Transaction): boolean =>
  !isTransactionClosed(transaction)
